// AUTO-GENERATED from the legacy PHP portal (lang/en.php). 392 keys.
// Regenerate with: npm run i18n:sync  (see tools/sync-lang.mjs)

export const en = {
  "org_name": "Pune Municipal Corporation",
  "dept_name": "Property Tax Department",
  "nav_home": "Home",
  "nav_about": "About",
  "nav_faqs": "FAQs",
  "nav_contact": "Contact",
  "nav_calculator": "Tax Calculator",
  "nav_signin": "Sign In/Sign Up",
  "nav_dashboard": "My Dashboard",
  "nav_logout": "Logout",
  "hero_kicker": "PAY YOUR PROPERTY TAX ONLINE",
  "hero_title_1": "QUICK, EASY &",
  "hero_title_2": "SECURE",
  "hero_tagline": "A few clicks is all it takes to manage your property tax affairs seamlessly",
  "search_ph": "Search property ID",
  "search_btn": "Search",
  "sample": "Sample",
  "feat_search_t": "Search Your Property",
  "feat_search_d": "Locate your property instantly using your Property ID (PID) and view complete details.",
  "feat_pay_t": "Pay Online Securely",
  "feat_pay_d": "Pay via UPI, credit/debit card or net banking and get your receipt instantly.",
  "feat_calc_t": "Estimate Your Tax",
  "feat_calc_d": "Use the tax calculator for an indicative estimate of your annual property tax.",
  "feat_hist_t": "Track Payment History",
  "feat_hist_d": "View all past bills, payments and download receipts anytime.",
  "search_title": "Search Property",
  "search_results": "Search Results",
  "no_results": "No property found for the entered Property ID. Please check the PID printed on your previous bill and try again.",
  "view_details": "View Details",
  "property_details": "Property Details",
  "pid": "Property ID (PID)",
  "old_pid": "Old Property No",
  "prop_type": "Property Type",
  "ward": "Ward",
  "zone": "Zone",
  "peth": "Peth / Section",
  "address": "Address",
  "status": "Status",
  "owners": "Owner(s)",
  "owner_name": "Owner Name",
  "owner_share": "Share %",
  "primary": "Primary",
  "dues_summary": "Current Dues",
  "total_outstanding": "Total Outstanding",
  "no_dues": "No outstanding dues. All bills are paid.",
  "view_bills": "View Bills",
  "view_history": "Payment History",
  "bills_title": "Property Tax Bills",
  "bill_no": "Bill No",
  "bill_date": "Bill Date",
  "due_date": "Due Date",
  "period": "Period",
  "bill_amount": "Bill Amount",
  "paid": "Paid",
  "outstanding": "Outstanding",
  "action": "Action",
  "view": "View",
  "pay_now": "Pay Now",
  "no_bills": "No bills found for this property.",
  "no_bills_pending_note": "No bills have been generated yet. You have a pending application below that may lead to your first assessment.",
  "no_tax_breakdown": "A tax-head breakdown isn't available for the current bill.",
  "of_bill": "of bill",
  "ward_benchmark_title": "How You Compare",
  "you": "You",
  "ward_average": "Ward Average",
  "citywide_average": "Citywide Average",
  "benchmark_note_lower": "You're paying less per sq.ft than most comparable properties",
  "benchmark_note_higher": "You're paying more per sq.ft than most comparable properties",
  "compared_in_ward": "in your ward",
  "compared_citywide": "citywide",
  "pending_applications": "Pending Applications",
  "view_application": "View Application",
  "bill_details": "Bill Details",
  "tax_head": "Tax Head",
  "taxable_base": "Taxable Base",
  "rate": "Rate %",
  "tax_amount": "Tax Amount",
  "rebate": "Rebate / Discount",
  "penalty": "Penalty",
  "line_total": "Line Total",
  "total_tax": "Total Tax",
  "total_rebate": "Total Rebate",
  "arrears": "Arrears (Late Payment)",
  "months_overdue": "months overdue",
  "net_amount": "Net Bill Amount",
  "total_payable": "Total Payable",
  "back": "Back",
  "checkout_title": "Payment Checkout",
  "checkout_all_title": "Pay Outstanding Bills",
  "select_bills_hint": "Select which bills to include in this payment.",
  "selected_total": "Selected Total",
  "select_at_least_one": "Select at least one bill to continue.",
  "bills_in_payment": "Bills in This Payment",
  "bill_in_payment": "Bill in This Payment",
  "pay_amount": "Amount to Pay",
  "full_amount": "Pay full outstanding",
  "partial_note": "You may pay a partial amount; the bill will remain in PARTIAL status until fully paid.",
  "partial_note_multi": "You may pay a partial amount; it will be applied to your oldest outstanding bills first.",
  "proceed_pay": "Proceed to Payment",
  "settling_payment": "Settling Payment…",
  "all_payments_success": "All selected bills have been paid successfully.",
  "some_payments_failed": "Some payments could not be completed — see details below.",
  "gateway_title": "PMC Secure Payment Gateway",
  "gateway_note": "This is a simulated payment gateway for demonstration. No real money is charged.",
  "upi": "UPI",
  "card": "Card",
  "netbanking": "Net Banking",
  "upi_id": "UPI ID",
  "card_no": "Card Number",
  "card_name": "Name on Card",
  "expiry": "Expiry (MM/YY)",
  "cvv": "CVV",
  "select_bank": "Select Bank",
  "pay_btn": "Pay",
  "simulate_fail": "Simulate Failure",
  "cancel": "Cancel",
  "pay_success": "Payment Successful!",
  "pay_success_d": "Your payment has been recorded and a receipt has been generated.",
  "pay_failed": "Payment Failed",
  "pay_failed_d": "Your payment could not be processed. No amount has been recorded against your bill. Please try again.",
  "receipt_no": "Receipt No",
  "payment_no": "Payment No",
  "txn_no": "Transaction No",
  "view_receipt": "View Receipt",
  "try_again": "Try Again",
  "receipt_title": "Payment Receipt",
  "receipt_date": "Receipt Date",
  "payment_mode": "Payment Mode",
  "amount_paid": "Amount Paid",
  "print_receipt": "Print Receipt",
  "receipt_footer": "This is a computer-generated receipt and does not require a signature.",
  "history_title": "Payment History",
  "payment_date": "Payment Date",
  "reference": "Reference",
  "receipt": "Receipt",
  "no_payments": "No payments found for this property yet.",
  "signin_title": "Citizen Sign In",
  "signup_title": "Citizen Registration",
  "full_name": "Full Name",
  "mobile": "Mobile Number",
  "email": "Email (optional)",
  "signin_btn": "Sign In",
  "signup_btn": "Register",
  "signin_help": "Sign in with your registered mobile number and any one of your linked Property IDs.",
  "signup_help": "Register with your name and mobile number, then link your property using its PID.",
  "no_account": "Don't have an account?",
  "have_account": "Already registered?",
  "signin_failed": "Sign in failed. Check your mobile number and linked Property ID.",
  "mobile_exists": "This mobile number is already registered. Please sign in.",
  "signup_ok": "Registration successful! Now link your property below.",
  "link_property": "Link a Property",
  "link_btn": "Link Property",
  "link_help": "Enter your Property ID (PID) exactly as printed on your bill. If the mobile number on the property record matches your registered mobile, it is verified automatically.",
  "linked_ok": "Property linked to your account.",
  "link_exists": "This property is already linked to your account.",
  "pid_not_found": "No property found with this PID.",
  "my_properties": "My Properties",
  "no_linked": "No properties linked yet. Link your first property using its PID.",
  "verified": "Verified",
  "unverified": "Unverified",
  "welcome": "Welcome",
  "calc_title": "Property Tax Calculator",
  "calc_note": "This calculator gives an indicative estimate only. Your actual tax is determined by PMC assessment and appears on your official bill.",
  "disclaimer_label": "Disclaimer",
  "usage_type": "Usage Type",
  "construction_type": "Construction Type",
  "residential": "Residential",
  "non_residential": "Non-Residential / Commercial",
  "open_plot": "Open Plot",
  "area_sqft": "Built-up Area (sq.ft.)",
  "rate_sqft": "Rate per sq.ft. per month (₹)",
  "calc_btn": "Calculate",
  "est_arv": "Estimated ARV",
  "est_tax": "Estimated Annual Tax",
  "early_note": "Pay before the due date to avoid monthly arrears. Early payment within the rebate window may earn a 5–10% discount as per PMC rules.",
  "contact_title": "Contact Us",
  "subject": "Subject",
  "message": "Message",
  "send_btn": "Submit Query",
  "fetch_details_btn": "Fetch Details",
  "fetching_btn": "Fetching…",
  "pid_verified": "Verified",
  "pid_fetch_not_found": "We couldn't find a property with this exact ID. Please check for typos and try again.",
  "pid_verify_hint": "Verify the Property ID above to fill this in",
  "contact_ok": "Your query has been submitted. Our team will get back to you shortly.",
  "helpline": "Helpline",
  "email_us": "Email",
  "office": "Head Office",
  "office_addr": "PMC Building, Shivajinagar, Pune - 411005, Maharashtra",
  "about_title": "About the Portal",
  "faqs_title": "Frequently Asked Questions",
  "dash_sub": "Manage your Property Taxes and services efficiently",
  "total_tax_amount": "Total Tax Pay Amount",
  "total_paid": "Total Paid",
  "total_properties": "Total Properties",
  "tab_overview": "Overview",
  "tab_properties": "Properties",
  "tab_schemes": "Schemes",
  "tab_services": "Services",
  "urgent_action": "Urgent Action Required",
  "due": "DUE",
  "outstanding_amt": "Outstanding Amount",
  "no_urgent": "Great! You have no pending dues on any linked property.",
  "recent_activity": "Recent Activity",
  "last_login": "Last Login",
  "view_more": "View More",
  "view_less": "View Less",
  "no_activity": "No activity yet. Your actions on the portal will appear here.",
  "notifications": "Notifications",
  "no_notifications": "No new notifications.",
  "nav_notifications": "Notifications",
  "notifications_title": "Notifications",
  "view_all_notifications": "View all notifications",
  "mark_all_read": "Mark all as read",
  "filter_all": "All",
  "filter_unread": "Unread",
  "no_notifications_page": "You have no notifications yet.",
  "notif_payment_paid": "Payment Received",
  "notif_payment_partial": "Partial Payment Recorded",
  "notif_app_accepted": "Application Accepted for Review",
  "notif_app_assigned": "Application Assigned to a Field Inspector",
  "notif_app_rejected": "Application Rejected",
  "notif_app_closed": "Application Closed",
  "notif_query_resolved": "Your Query Has Been Resolved",
  "notif_bill_overdue": "Payment Overdue",
  "notif_col_notification": "Notification",
  "notif_col_when": "When",
  "schemes_empty": "Rebate and amnesty schemes announced by PMC will appear here. No schemes are currently open.",
  "services_empty": "More citizen services are coming soon.",
  "svc_calculator": "Tax Calculator",
  "svc_calculator_d": "Estimate your annual property tax.",
  "svc_history": "Payment History",
  "svc_history_d": "View past payments and download receipts.",
  "svc_query": "Raise a Query",
  "svc_query_d": "Contact the Property Tax Department.",
  "svc_faq": "FAQs",
  "svc_faq_d": "Answers to common questions.",
  "nav_property": "Property",
  "nav_paytax": "Pay Tax",
  "nav_taxdetails": "Tax Details",
  "nav_services": "Services",
  "nav_faq": "FAQ",
  "link_this": "Link this property to my account",
  "not_linked_note": "This property is not linked to your account yet.",
  "act_linked": "Property Linked Successfully",
  "act_pay_ok": "Property Tax Payment Received",
  "act_pay_fail": "Property Tax Payment Failed",
  "act_registered": "Account Created Successfully",
  "act_bill": "Property Tax Bill Generated",
  "change_property": "Change Property",
  "bd_doc_title": "Property Tax Bill",
  "bd_doc_title_cda": "Property Tax — Change in Dakhala Difference Bill",
  "bd_property_details": "Property Details",
  "bd_owner_details": "Owner Details",
  "bd_arv": "Annual Rateable Value",
  "bd_arv_cda": "Annual Rateable Value — Change in Dakhala",
  "bd_arv_uc": "Annual Rateable Value — Illegal / Unauthorised Construction",
  "bd_tax_bill": "Property Tax Bill",
  "bd_pid": "Property ID",
  "bd_fin_year": "Fin Year",
  "bd_meter_no": "NonResi Meter No",
  "bd_assess_date": "Assessment Date",
  "bd_last_payment": "Last Payment",
  "bd_print_date": "Bill Print Date",
  "bd_name": "Name",
  "bd_addr": "Address",
  "bd_prop_desc": "Property Description",
  "bd_resident": "Resident",
  "bd_non_resident": "Non Resident",
  "bd_gen_exmp": "General Exemption",
  "bd_total": "Total",
  "bd_total_arv": "Total ARV",
  "bd_arv_component": "ARV Component",
  "bd_prev_arv": "Previous ARV",
  "bd_new_arv": "New ARV",
  "bd_old_arv": "Old ARV",
  "bd_old_x": "Old Annual Tax (×1)",
  "bd_new_x": "Tax at ×",
  "bd_uc_reference_suffix": " (reference)",
  "bd_change": "Surcharge (Billed)",
  "bd_uc_arv_note_prefix": "The ARV is not revised for this scheme. The penalty (×",
  "bd_uc_arv_note_suffix": ") is charged on the old assessment's tax — see Tax Bill below.",
  "bd_uc_surcharge_formula_note": "This UC penalty bill is raised separately from — and in addition to — the regular annual bill, which already collects the old tax at ×1. So only the surcharge is billed here.",
  "bd_kalavidhi": "Kalavidhi Period",
  "bd_days": "days",
  "bd_to": "to",
  "bd_tax_pct": "Tax %",
  "bd_apr_sep": "April–September",
  "bd_oct_mar": "October–March",
  "bd_fixed": "Fixed",
  "bd_year_tax": "Year Tax Amount",
  "bd_diff_amount": "Difference Amount",
  "bd_annual_tax_amount": "Annual Tax Amount",
  "bd_billing_period": "Billing Period Demand",
  "bd_prorated_note_title": "Prorated Bill from",
  "bd_prorated_note_body": "This property was registered mid-year. Tax demand is calculated for the active period",
  "bd_prorated_note_days_prefix": "Active for",
  "bd_prorated_note_days_of": "days of",
  "bd_prorated_note_days_suffix": "in {period}",
  "bd_prorated_note_years_suffix": "years factor",
  "bd_prorated_note_tail": " based on effective registration date.",
  "bd_self_occupied_arv_conc": "Self-Occupied ARV Concession",
  "bd_difference": "Difference",
  "bd_no_tax_lines": "No tax lines found",
  "bd_normal_demand": "Current demand",
  "bd_uc_tax_demand": "Illegal / Unauthorised Tax Demand",
  "bd_ff_exmp": "Fire Fighter Exemption (non-compulsory taxes zeroed)",
  "bd_sra_conc": "SRA Slum Scheme Concession",
  "bd_village_conc": "Village Phase Concession",
  "bd_year": "Year",
  "bd_of5": "of 5",
  "bd_entry": "Entry",
  "bd_net_after_conc": "Net Tax Demand (after concessions)",
  "bd_dakhala_mult": "Dakhala Multiplier",
  "bd_normal_rate": "Normal Rate",
  "bd_adj_demand": "Adjusted Current Demand",
  "bd_solar_disc": "Solar/Vermi/Rain Harvest Disc.",
  "bd_prior_arrears": "Prior Period Arrears",
  "bd_carried_fwd_from": "Outstanding balance carried forward from",
  "bd_cf_mismatch_warning": "This carried-forward balance is not included in the Net Bill Amount below. Please contact the Property Tax office to confirm the total payable.",
  "bd_superseded_warning": "This bill was cancelled and replaced by {bill}. The figures shown here are from the original, incorrect calculation and are not payable.",
  "bd_gp_arrear": "Gram Panchayat Tax Arrear (Village Base — fixed, 100%)",
  "bd_overdue_penalty": "Overdue Penalty",
  "bd_excess": "Excess Amount",
  "bd_early_disc": "Discount for early payment",
  "bd_arrears_penalty": "Arrears +2% Pen",
  "bd_net_bill": "Net Bill Amount",
  "bd_net_bill_current": "Net Bill Amount (current year)",
  "bd_register_snapshot_as_at": "register snapshot as at",
  "bd_total_as_per_register": "Total as per Register",
  "bd_payable_today_current_only": "current year only — prior period arrears not included",
  "bd_ledger_settled": "Settled",
  "bd_ledger_settled_note": "PMC's property tax records show this bill as settled — no amount is outstanding, so it cannot be paid again through this portal. If you believe this is wrong, please contact the Property Tax office.",
  "bd_in_credit": "Credit of",
  "bd_credit_note": "This bill is in credit: the excess amount already paid on this property is more than this year's demand, so nothing is payable. Please contact the Property Tax office about the credit balance.",
  "bd_live_ledger": "Live Ledger Balance",
  "bd_ledger_arrears": "Arrears outstanding (earlier years)",
  "bd_ledger_current": "Current year still owed",
  "bd_ledger_current_hint": "tax, net of penalty",
  "bd_ledger_total": "Total owed as at last refresh",
  "bd_ledger_of_tax": "of that total, property tax",
  "bd_ledger_of_penalty": "of that total, accrued penalty",
  "bd_ledger_penalty_pct": "of what is owed",
  "bd_ledger_diff": "Difference vs the register snapshot above",
  "bd_ledger_diff_hint": "the ledger has moved since the bill was printed",
  "bd_ledger_asat": "Account ledger figures as at",
  "bd_ledger_note": "Shown for information only — this is not the amount payable through this portal, which covers the current year's bill above. These figures are a periodic snapshot of your Property Tax account and do not include any payment made after the time shown. Please confirm the exact amount due with the Property Tax office before settling arrears.",
  "bd_ledger_stale": "This snapshot is more than two days old.",
  "bd_in_words": "In Words",
  "bd_total_arrears": "Total Arrears",
  "bd_payable_today": "Total Payable Today",
  "bd_penalty_note": "Penalty difference billed (annual)",
  "bd_owner_sign": "Property Owner's Signature",
  "bd_auth_sign": "Authorised Signatory — PMC",
  "bd_computer_note": "This is a computer-generated bill. No signature required for online payments.",
  "bd_print": "Print Bill",
  "bd_overdue_title": "Bill Overdue",
  "bd_overdue_msg": "%d month(s) past due date — arrears of %s have been applied on nominated tax heads. Total payable today: %s.",
  "bd_village_banner_t": "Village Jurisdiction Property",
  "bd_village_phase": "Phase factor: %s%% of DIFFERENCE + GP Base. PMC Entry: %s. Water Tax: flat 20%% of PMC water rate. EDU, NEDU, EGAR, LP taxes at 100%%.",
  "bd_village_full": "Full PMC tax applies (Year 5+ or pre-2022 village). Water Tax: flat 20% of PMC water rate.",
  "svc_pt1": "PT1 - New Taxation Service",
  "svc_pt1_d": "Apply for first-time assessment of a new property.",
  "svc_pt1_track": "My Applications",
  "svc_pt1_track_d": "Track your service applications.",
  "pt1_title": "PT1 - New Taxation Service",
  "pt1_short": "PT1 Application Fee",
  "pt1_sub": "Application for first-time property tax assessment of a newly constructed / unassessed property",
  "pt1_intro": "Use this service to register a newly constructed or not-yet-assessed property for property tax. After submission, PMC will inspect and assess the property and allot a new Property ID (PID).",
  "pt1_step1": "Application Details",
  "pt1_step2": "Upload Documents",
  "pt1_step3": "Review & Pay",
  "pt1_step4": "Acknowledgment",
  "pt1_sec_location": "Property Location",
  "pt1_sec_applicant": "Applicant Details",
  "pt1_sec_property": "New Property Address",
  "svc_sec_details": "Additional Details",
  "pt1_sec_construction": "Construction Details",
  "pt1_sec_documents": "Documents",
  "pt1_addr1": "Address Line 1",
  "pt1_addr2": "Address Line 2",
  "pt1_locality": "Locality / Area",
  "pt1_city": "City",
  "pt1_pin": "PIN Code",
  "pt1_mixed": "Mixed Use",
  "pt1_construction_type": "Construction Type",
  "pt1_ct_rcc": "RCC",
  "pt1_ct_lb": "Load Bearing / Brick",
  "pt1_ct_patra": "Patra Shed / Temporary",
  "pt1_ct_open": "Open Land",
  "pt1_floors": "Total Floors",
  "pt1_construction_end": "Construction Completion Date",
  "pt1_select": "-- Select --",
  "pt1_save_proceed": "Save & Proceed",
  "pt1_upload_note": "Upload required (*) documents in jpg, jpeg, png, or pdf format (max 10MB). Documents must be self-attested.",
  "pt1_doc_8a": "8A / 7/12 Extract",
  "pt1_doc_sale": "Sale Deed / Registered Agreement",
  "pt1_doc_index2": "Index II",
  "pt1_doc_nodues": "Property Tax No Dues Certificate",
  "pt1_doc_map": "Property-related Map",
  "pt1_doc_occ": "Occupancy Certificate",
  "pt1_choose_file": "Choose File",
  "pt1_no_file": "No File Chosen...",
  "pt1_uploaded": "Uploaded",
  "pt1_not_uploaded": "Not uploaded",
  "pt1_up_err_size": "File exceeds the 10MB limit.",
  "pt1_up_err_type": "Only jpg, jpeg, png or pdf files are allowed.",
  "pt1_up_err_generic": "Upload failed. Please try again.",
  "pt1_up_err_required": "This document is required.",
  "pt1_source_pid": "Applied via PID",
  "pt1_edit_details": "Edit Details",
  "pt1_edit_docs": "Edit Documents",
  "pt1_fee_title": "Total Fee",
  "pt1_fee_note": "A one-time, non-refundable application processing fee is payable online to submit this application.",
  "pt1_confirm_pay": "Confirm & Pay",
  "pt1_app_no": "Application No",
  "pt1_ack_title": "Application Acknowledgment",
  "pt1_applied_on": "Applied On",
  "pt1_submitted_on": "Submitted On",
  "pt1_submitted_t": "Application submitted successfully!",
  "pt1_submitted_d": "Your fee payment was received and your application has been forwarded to PMC for assessment.",
  "pt1_incomplete_note": "This application is not yet submitted. Complete the remaining steps to submit it.",
  "pt1_next_note": "What happens next: a PMC assessor will verify your documents and inspect the property. After assessment, a new Property ID (PID) will be allotted and your first property tax bill will be generated. Keep the Application No for reference.",
  "pt1_print_ack": "Print Acknowledgment",
  "pt1_resume": "Resume",
  "pt1_track_title": "My Applications",
  "pt1_track_sub": "Enter your Application No to view its status and acknowledgment",
  "pt1_docs_count": "Documents Uploaded",
  "pt1_err_mobile": "Enter a valid 10-digit mobile number.",
  "pt1_err_email": "Enter a valid email address.",
  "pt1_err_pin": "Enter a valid 6-digit PIN code.",
  "pt1_err_area": "Enter the built-up area in sq.ft.",
  "pt1_err_date": "Enter a valid past date.",
  "pt1_public_cta_t": "New property not yet assessed for property tax?",
  "pt1_public_cta_apply": "Apply: PT1 - New Taxation Service",
  "pt1_public_cta_track": "Track Application",
  "pt1_find_title": "Find an Application",
  "pt1_not_found": "No application found with this Application No.",
  "pt1_keep_no": "Note your Application No — you can return anytime from the home page and open this application by entering it under Track Application.",
  "svc_pt2": "PT2 - Re-Taxation Service",
  "svc_pt2_d": "Apply for re-assessment after extension or change of use of your property.",
  "pt2_title": "PT2 - Re-Taxation Service",
  "pt2_short": "PT2 Application Fee",
  "pt2_sub": "Application for re-assessment of an already assessed property after a change",
  "pt2_intro": "Use this service when your assessed property has changed — e.g. additional construction / extension or a change of use (residential ↔ non-residential). PMC will re-inspect the property and revise its tax assessment under the same PID.",
  "pt2_sec_property": "Assessed Property",
  "pt2_sec_change": "Change Details",
  "pt2_reason": "Reason for Re-Taxation",
  "pt2_reason_ext": "Extension / Additional Construction",
  "pt2_reason_use": "Change of Usage",
  "pt2_prev_usage": "Current Usage",
  "pt2_new_usage": "Usage After Change",
  "pt2_addl_area": "Additional Area (sq.ft.)",
  "pt2_total_area": "Total Area After Change (sq.ft.)",
  "pt2_change_date": "Change Completion Date",
  "pt2_change_desc": "Description of Change",
  "pt2_doc_permit": "Sanctioned Building Plan / Permission",
  "pt2_err_reason": "Select the reason for re-taxation.",
  "pt2_err_addl_area": "Enter the additional built-up area in sq.ft.",
  "pt2_err_usage_same": "Usage after the change must differ from the current usage.",
  "pt2_submitted_d": "Your fee payment was received and your re-taxation application has been forwarded to PMC for re-assessment.",
  "pt2_next_note": "What happens next: a PMC assessor will verify your documents and re-inspect the property. The revised assessment will reflect in your future property tax bills under the same PID. Keep the Application No for reference.",
  "svc_leave_title": "Leave this application?",
  "svc_leave_msg": "Your application is not yet submitted. If you leave now, all entered details and uploaded documents will be discarded.",
  "svc_leave_stay": "Continue Application",
  "svc_leave_discard": "Discard & Leave",
  "svc_draft_note": "Note: your application is not saved until the application fee is paid. If you leave this service or close the browser before completing the payment, all entered details and uploaded documents will be discarded.",
  "svc_myapps_title": "Applications for this Property",
  "svc_myapps_none": "No applications have been submitted for this property yet.",
  "svc_service": "Service",
  "svc_view": "View",
  "svc_required_title": "Required Fields Missing",
  "svc_required_msg": "Please fill in the following required fields before proceeding:",
  "svc_required_ok": "OK, Let Me Fill Them",
  "required": "This field is required.",
  "error_generic": "Something went wrong. Please try again.",
  "footer_rights": "Pune Municipal Corporation. All rights reserved.",
  "quick_links": "Quick Links",
  "get_in_touch": "Get in Touch",
  // ── Added for the React portal (no PHP equivalent) ──
  "apply_now": "Apply Now",
  "next": "Next",
  "print": "Print",
  "upload": "Upload",
  "replace": "Replace",
  "remove": "Remove",
  "required_short": "Required",
  "built_area": "Built-up Area (sq.ft.)",
  "built_year": "Year Built",
  "total_billed": "Total Billed",
  "est_half": "Estimated Half-Yearly Tax",
  "calc_sub": "Get an indicative estimate of your annual property tax.",
  "calc_ward": "Ward",
  "calc_peth": "Peth",
  "calc_select_ward": "Select ward",
  "calc_select_peth": "Select peth",
  "faq_sub": "Answers to the questions citizens ask most often.",
  "contact_sub": "Raise a query and our team will respond shortly.",
  "svc_intro": "Apply online for property tax services.",
  "svc_needs_pid": "Locate your Property ID first.",
  "bill_footer": "This is a computer-generated bill and does not require a signature.",
  "age_not_overdue": "Not overdue",
  "age_1_3": "1-3 months",
  "age_4_6": "4-6 months",
  "age_7_12": "7-12 months",
  "age_12_plus": "12+ months",
  "update_contact_details": "Update Contact Details",
  "update_contact_details_desc": "Update the mobile number and email on file for this property.",
  "save": "Save",
  "captcha_title": "Security Check",
  "captcha_prompt": "Solve this to confirm you're not a robot",
  "captcha_answer": "Your Answer",
  "captcha_refresh": "Get a new question",
  "captcha_incorrect": "Incorrect answer. Please try again.",
  "captcha_required": "Answer the security question to continue.",
  "invalid_mobile": "Enter a valid 10-digit mobile number.",
  "invalid_email": "Enter a valid email address.",
  "contact_updated": "Contact details updated successfully.",
  "topbar_brand": "PMC - Citizen Portal",
  "nav_myqueries": "My Queries",
  "myqueries_title": "My Queries",
  "myqueries_sub": "Queries you've raised for this property through Contact Us.",
  "myqueries_none": "You haven't raised any queries for this property yet.",
  "myqueries_received": "Raised",
  "myqueries_answer": "Answer",
  "myqueries_pending": "Awaiting a response from the Property Tax Department.",
  "myqueries_no_remarks": "Resolved, with no additional remarks.",
  "myqueries_resolved_on": "Resolved on",
  "myqueries_new": "Raise a Query",
  "myqueries_dept_response": "Response from the Property Tax Department",
  "svc_already_open": "Request Already Open",
  "svc_already_open_note": "You already have an open request for this service on this property.",
  "svc_not_eligible": "Not Eligible",
  "svc_not_eligible_property": "This property is not eligible for this service.",
  "svc_view_my_applications": "View My Applications",
  "svc_pt5_outstanding_title": "Pay Pending Dues First",
  "svc_pt5_outstanding_msg": "You have a pending Total Outstanding amount of {amount}. Please pay the pending Total Outstanding amount first before applying for {service}.",
  "svc_pay_outstanding_btn": "Pay Pending Dues",
  "svc_pt5_transfer_fee": "Transfer Fee",
  "svc_pt5_cfc_charges": "Application Fee",
  "svc_pt5_base_fee": "Base Fee",
  "svc_pt5_excess_rv": "Excess Ratable Value (RV)",
  "svc_pt5_slabs": "Slabs",
  "svc_pt5_exempt": "Exempted",
  "myqueries_new_desc": "Your query will be sent to the Property Tax Department and will appear in this list once submitted.",
  "close": "Close",
  "svc_rejected_t": "Application Rejected",
  "svc_rejected_d": "Your application could not be approved. See the reason below.",
  "svc_reject_reason": "Reason",
  "svc_reject_remarks": "Remarks",
  "footer_system_name": "PMC Property Tax System",
  "footer_secure_system": "Secure System",
  "hero_badge_pill": "CITIZEN SERVICES, SIMPLIFIED",
  "hero_title_line1": "Your property tax,",
  "hero_title_line2": "made simple.",
  "hero_subtitle": "Search, review and pay your Pune property tax online — with a secure experience designed around you.",
  "hero_secure_payments": "Secure payments",
  "hero_available_247": "Available 24 × 7",
  "search_card_kicker": "PROPERTY SERVICES",
  "search_card_title": "Search your property",
  "search_card_subtitle": "View details, dues and payment history.",
  "search_card_pid_label": "PROPERTY ID (PID)",
  "search_card_pid_hint": "Find your PID on your previous property tax bill.",
  "search_card_security_check": "SECURITY CHECK",
  "search_card_your_answer": "YOUR ANSWER",
  "search_card_answer_ph": "Answer",
  "searching": "Searching…",
  "pid_required": "Please enter a Property ID (PID)",
  "pid_max_length": "Property ID must not exceed 18 characters",
  "feat_kicker": "EVERYTHING IN ONE PLACE",
  "feat_heading_line1": "A simpler way to stay",
  "feat_heading_line2": "on top of your tax.",
  "feat_section_subtitle": "From your first search to your final receipt, the essentials are designed to be clear, quick and easy to access.",
  "helpful_kicker": "NEED A HAND?",
  "helpful_title": "Helpful links",
  "helpful_subtitle": "Quick access to the most requested property tax services.",
  "helpful_calc_desc": "Estimate your indicative annual property tax.",
  "helpful_track_desc": "Check the status of your new taxation request.",
  "helpful_faqs_title": "FAQs & guides",
  "helpful_faqs_desc": "Find answers to common property tax questions.",
  "helpline_kicker": "OFFICIAL CITIZEN PORTAL",
  "helpline_title": "Need assistance with your property tax?",
  "helpline_subtitle": "Our helpline is available to help you complete your payment journey.",
  "helpline_btn": "Call 1800 1030 222",
  "search_pid_ph": "Enter your Property ID",
  "example": "Example",
  "security_check": "Security Check",
  "security_check_sub": "Solve this to confirm you're not a robot",
  "your_answer_ph": "Your Answer",
  "enter_answer_ph": "Enter answer",
  "search_property_btn": "Search Property",
  "enter_pid_ph": "Enter Property ID (PID)",
  "try_another": "Try another",
  "enter_name_ph": "Enter your full name",
  "enter_mobile_ph": "Enter 10 digit mobile number",
  "select_subject": "Select subject",
  "subj_bill": "Property Tax Bill / Assessment Query",
  "subj_payment": "Payment or Receipt Issue",
  "subj_ownership": "Name Correction / Ownership Transfer",
  "subj_arv": "Annual Rateable Value (ARV) Dispute",
  "subj_rebate": "Rebate / Concession Scheme",
  "subj_correction": "Property Details Correction",
  "subj_other": "General Inquiry / Other",
  "message_ph": "Type your message here...",
  "status_active": "Active",
  "status_inactive": "Inactive",
  "applicant_name": "Applicant Name",
  "applicant_mobile": "Mobile Number",
  "applicant_email": "Email Address",
  "mobile_help_text": "10-digit mobile number",
  "email_help_text": "e.g. name@example.com",
  "select_field": "Select {field}",
  "doc_upload_info": "JPG, PNG or PDF · max {max} MB per file",
  "calc_fee_pending": "Calculating Application Fee…",
  "fix_highlighted_errors": "Please correct the highlighted fields before proceeding.",
  "val_err_required": "{field} is required",
  "val_err_name_len": "Name must be at least 2 characters",
  "val_err_name_chars": "Name should only contain letters and spaces",
  "val_err_mobile": "Enter a valid 10-digit mobile number (e.g. 9876543210)",
  "val_err_email": "Enter a valid email address (e.g. name@example.com)",
  "val_err_number": "Enter a valid number",
  "val_err_negative": "Value cannot be negative",
  "val_err_date": "Enter a valid date",
  "svc_pt5_fallback_label": "PT5 Title Transfer Form",
  "svc_pt5_desc": "Apply for title transfer or ownership name change of your assessed property.",
  "chip_village_phased": "Village phased billing",
  "chip_sra": "SRA concession",
  "chip_ff_exemption": "Fire-fighter exemption",
  "calc_lookup_error": "We could not load the ward, peth or financial-year list. Please try again.",
  "calc_estimate_error": "We could not calculate the estimate right now. Please try again.",
  "app_access_locate": "This application is not open in this browser. Search its Property ID first, or open it with its Application Number under Track Application.",
  "tab_search_by_pid": "Search by PID",
  "tab_search_by_property_id": "Search by Property ID",
  "tab_login_mobile_otp": "Login with Mobile OTP",
  "login_mobile_otp_title": "Login via Mobile OTP",
  "login_mobile_otp_subtitle": "Locate & access your properties using your registered mobile number.",
  "login_mobile_otp_subtitle_search": "Locate & view all properties linked to your registered mobile number using OTP.",
  "send_otp": "Send OTP",
  "otp_sent_success": "OTP Sent Successfully",
  "change_mobile": "Change Mobile Number",
  "enter_4digit_otp": "ENTER 4-DIGIT OTP",
  "enter_otp_ph": "Enter 4-digit OTP (1234)",
  "verify_otp_login": "Verify OTP & Login",
  "select_property_to_open": "Select Property to Open",
  "found_properties_for_mobile": "Found {count} properties for +91 {mobile}",
  "view_property": "View Property",
  "svc_pt3_label": "PT3 - 40% Exemption",
  "svc_pt3_desc": "Apply for 40% residential property tax concession.",
  "svc_ndc_label": "No Dues Certificate (Property Tax)",
  "svc_ndc_desc": "Apply for issuance of a No Objection Certificate (NOC) for the property",
  "btn_generate_noc": "Generate NOC",
  "doc_approved_building_plan_layout": "Approved building plan / layout",
  "doc_updated_via_api_db_tamper": "Updated via API after Direct DB Tamper",
} as const;

export type TranslationKey = keyof typeof en;
